import { styled } from "styled-components";

const AvatarFrame = styled.div<{ $profilePictureUrl?: string | null }>`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-image: ${({ $profilePictureUrl }) =>
    $profilePictureUrl ? `url(${$profilePictureUrl})` : "none"};
  background-color: ${({ $profilePictureUrl }) =>
    $profilePictureUrl ? "transparent" : "var(--bs-secondary-bg)"};
`;

const PlaceholderIcon = styled.i`
  font-size: 20px;
`;

const UserAvatar = ({
  profile_picture_url,
}: {
  profile_picture_url?: string | null;
}) => (
  <AvatarFrame $profilePictureUrl={profile_picture_url}>
    {!profile_picture_url && (
      <PlaceholderIcon aria-hidden="true" className="bi-person m-auto" />
    )}
  </AvatarFrame>
);

export default UserAvatar;
